module.exports = __webpack_public_path__ + "static/media/iPhone.2744db62.webp";